import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { VIEWPORT_REMAINDER } from './AppViewport';

/**
 * The frame of every page a person without an account opens — sign-in, register, an invitation, a
 * reporter's own page, the reset and unsubscribe pages (F-0266 RL-1e, I-0703).
 *
 * It draws the one `main` landmark those pages have, as `Layout` draws the app's: a page names its
 * content with a heading and never draws a `main` of its own. It keeps the viewport's column, so a
 * page below it takes the remainder of the window exactly as it did before (`VIEWPORT_SCREEN`).
 */
export function PublicLayout() {
  return (
    <PublicFrame>
      <Outlet />
    </PublicFrame>
  );
}

/**
 * The same frame for a public page that is not a route of the public layout's own (F-0338: a Public
 * work area is drawn at its address, which `ProtectedRoute` answers for a visitor with no session). The
 * one `main` landmark lives here, so no page draws a second.
 */
export function PublicFrame({ children }: { children: ReactNode }) {
  return <main className={`flex flex-col ${VIEWPORT_REMAINDER}`}>{children}</main>;
}
